import { Component } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { incrementAction } from "../store/actions/test.actions";
import { LocaleService } from "../shared/services/locale.service";

@Component({
  selector: "app-mobile",
  templateUrl: "./mobile.component.html",
  styles: [],
})
export class MobileComponent {
  test$: Observable<number>;
  culture: string;
  constructor(private store: Store<TestAppState>, private localeService: LocaleService) {
    this.culture = this.localeService.locale;
    this.test$ = store.pipe(select("test"));
  }

  increment(count = 1) {
    this.store.dispatch(incrementAction({ payload: { count: count } }));
  }
}
